module.exports = __webpack_public_path__ + "img/netent-white.a95293f9.svg";